module.exports = __webpack_public_path__ + "img/pulse_logo.c1109c25.svg";